import GenericGauge from "./GenericGauge";

export default function SmallEntityTypeCardGauge({ value }) {
  const settings = {
    r: 32,
    x0: 43,
    y0: 3,
    width: 90,
    height: 120,
    imgDimension: 96,
    boxWidth: "50px",
    boxHeight: "50px",
  };
  return (
    <GenericGauge
      settings={settings}
      value={value}
      tooltipText="Protected entities out of total"
    />
  );
}
